import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import pluralize from 'pluralize'

import {
  Col,
  Row,
  DetailList,
  Link
} from 'camino-react'

const ListOfLinkedItems = ({
  clients,
  tickets,
  problems,
  loadingClient,
  clientNotices
}) => (

  <Row noGutters>
    <Col>
      <DetailList
        list={[
          _.some(clientNotices) && {
            title: pluralize('Client', clients.length),
            content: loadingClient || _.map(clients, client => (
              <>
                {`#${client.id} - ${client.short_name}`}
                <br />
                <br />
              </>
            ))
          },
          _.some(tickets) && {
            title: pluralize('Ticket', tickets.length),
            content: _.map(tickets, ({ ticket_href: ticketHref, item: { id, title } }) => (
              <Link href={ticketHref}>
                {`#${id} - ${title}`}
                <br />
                <br />
              </Link>
            ))
          },
          _.some(problems) && {
            title: pluralize('Problem', problems.length),
            content: _.map(problems, ({ problem_href: problemHref, item: { id, issue } }) => (
              <Link href={problemHref}>
                {`#${id} - ${issue}`}
                <br />
                <br />
              </Link>
            ))
          }
        ]}
      />
    </Col>
  </Row>
)

export default ListOfLinkedItems

ListOfLinkedItems.propTypes = {
  clients: PropTypes.arrayOf(PropTypes.object).isRequired,
  tickets: PropTypes.arrayOf(PropTypes.object).isRequired,
  problems: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadingClient: PropTypes.string.isRequired,
  clientNotices: PropTypes.arrayOf(PropTypes.object).isRequired
}